/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ProductAlertDTO
 */
export interface ProductAlertDTO {
  /**
   *
   * @type {string}
   * @memberof ProductAlertDTO
   */
  ean: string;
}

/**
 * Check if a given object implements the ProductAlertDTO interface.
 */
export function instanceOfProductAlertDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "ean" in value;

  return isInstance;
}

export function ProductAlertDTOFromJSON(json: any): ProductAlertDTO {
  return ProductAlertDTOFromJSONTyped(json, false);
}

export function ProductAlertDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductAlertDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    ean: json["ean"]
  };
}

export function ProductAlertDTOToJSON(value?: ProductAlertDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    ean: value.ean
  };
}
